export class UTime {
  public static format_HH_MM(minutes: number): string {
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    return `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}`;
  }

  public static minuteMs(min: number): number {
    return 1000 * 60 * min;
  }
}
